import React, { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import { useDispatch, useSelector } from "react-redux"
import { getPieChartData } from "store/actions"
// import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";

const PieChart = ({ dataColors }) => {
  //   const PieApexChartColors = getChartColorsArray(dataColors);
  const { pieChartData } = useSelector(state => ({
    pieChartData: state.GetPieChart.pieChart?.data
  }))
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getPieChartData())
  }, [])
  const [Series, setSeries] = useState([])
  useEffect(() => {
    let pieChart = []
    if (pieChartData) {
      pieChart[0] = pieChartData?.totalByShipExport
      pieChart[1] = pieChartData?.totalByShipImport
      pieChart[2] = pieChartData?.totalByAirExport
      pieChart[3] = pieChartData?.totalByAirImport
      setSeries(pieChart)
    }
  }, [pieChartData])

  const series = Series
  const options = {
    chart: {
      height: 320,
      type: 'pie',
    },
    labels: ["Sea Export", "Sea Import", "Air Export", "Air Import"],
    // colors: PieApexChartColors,
    colors: ['#969696', '#ECD142', '#FF9649','#E7415E'],

    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      verticalAlign: 'middle',
      floating: false,
      fontSize: '14px',
      offsetX: 0,
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: {
          height: 240
        },
        legend: {
          show: false
        },
      }
    }]
  }

  return (

    <ReactApexChart options={options} series={series} type="pie" height="400" />
  )
}

export default PieChart
